<!--
 * @Author: LiuMeiYu
 * @Date: 2022-03-03 17:09:34
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-02-10 17:11:11
 * @FilePath: \Nivara\src\App.vue
 * @Description: *
 * *
 * Copyright (c) 2022 by yihua, All Rights Reserved.
-->
<template>
  <router-view></router-view>
</template>

<script>
import { onMounted, ref } from "@vue/runtime-core";
export default {
  name: "App",
  components: {},
  setup() {
    let beginTime = ref(); //开始时间
    let differTime = ref(0); //时间差

    const beforeunloadHandler = () => {
      beginTime.value = new Date().getTime();
    };

    const unloadHandler = () => {
      differTime.value = new Date().getTime() - beginTime.value;
      if (differTime.value <= 5) {
        // 浏览器关闭
        localStorage.removeItem("token");
        localStorage.removeItem("country_id");
        localStorage.removeItem("currency_name");
        localStorage.removeItem("userId");
        localStorage.removeItem("userInfo");
      }
    };
    onMounted(() => {
      window.addEventListener("beforeunload", () => beforeunloadHandler());
      window.addEventListener("unload", () => unloadHandler());
    });
    return {};
  },
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
  min-width: 969px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
}
a {
  text-decoration-line: none;
}
ul ul {
  list-style: none;
}
&::-webkit-scrollbar {
  width: 8px; /*滚动条宽度*/
  height: 10px; /*滚动条高度*/
}
&::-webkit-scrollbar-track {
  box-shadow: 0px 1px 3px #f8f8f8 inset; /*滚动条的背景区域的内阴影*/
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  background-color: #f8f8f8; /*滚动条的背景颜色*/
}
&::-webkit-scrollbar-thumb {
  box-shadow: 0px 1px 3px #03034d inset; /*滚动条的内阴影*/
  border-radius: 10px; /*滚动条的圆角*/
  background-color: #03034d; /*滚动条的背景颜色*/
}
.cancel-button-style {
  color: #0f4392 !important;
}
.el-notification .el-icon-success {
  color: green !important;
}
</style>
